/* unplugin-vue-components disabled */import { render } from "./ReferenceTable1.vue?vue&type=template&id=a2104514&scoped=true&ts=true"
import script from "./ReferenceTable1.vue?vue&type=script&lang=ts"
export * from "./ReferenceTable1.vue?vue&type=script&lang=ts"

import "./ReferenceTable1.vue?vue&type=style&index=0&id=a2104514&scoped=true&lang=less"
import "./ReferenceTable1.vue?vue&type=style&index=1&id=a2104514&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/test-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2104514"]])

export default __exports__